import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "inquiry end"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h2", null, "支払方法登録完了", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "inner" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "支払方法登録が完了しました。")
], -1);
const _hoisted_6 = { class: "bt_home" };
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'payment_end',
    props: {
        common: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _hoisted_5,
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_unref(Link), {
                                    href: _ctx.route('plan.show'),
                                    class: "bt_home"
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode("料金プラン変更に戻る")
                                    ]),
                                    _: 1
                                }, 8, ["href"])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
